export const ONBOARDING_INITIALIZE_DELAY = 1000;
export const ONBOARDING_STEP_POPOVER_OPEN_DELAY = 500;
export const ONBOARDING_STEP_POPOVER_WIDTH = 265;

// Guide Offsets: positions the popover to point to the correct element for each step
export const ONBOARDING_GUIDE_OFFSETS = {
  ADD_CONTACT_1: 80,
  ADD_CONTACT_1_ALT: 50,
  SAVE_EMAIL_1: 80,
  SAVE_EMAIL_1_ALT: 35,
  SAVE_EMAIL_2: 90,
  ENTRY_ACTIONS_1: 90,
  ENTRY_ACTIONS_1_ALT: 35,
  ENTRY_ACTIONS_2: -5,
  ENTRY_ACTIONS_3: 30,
};
